import { uniq } from 'lodash';
import { call, put, SagaReturnType, select, takeEvery } from 'redux-saga/effects';
import {
  doFailedRefreshPositionList,
  doSucceededGetPositionList,
  doSucceededGetQuoteList,
  doSucceededRefreshPositionList,
} from 'src/actions';
import { State, Type } from 'src/actions/utils';
import { getClientApi, PositionApi, PrivateQuoteApi, QuoteApi } from 'src/data-communication';
import { GetPositionListDto } from 'src/dtos';
import { mapPositionListDtoToModel } from 'src/mappers';

import { TReduxAction } from '../typings/commonTypes';

import { safeSaga } from './utils';

function* list(action: TReduxAction) {
  const { authToken } = yield select(state => state.auth.data);
  const dto: GetPositionListDto = action?.payload;
  const { data, total }: SagaReturnType<PositionApi['list']> = yield call(getClientApi().position.list, {
    ...dto,
    authToken,
  });
  const privateQuotesResponse: SagaReturnType<PrivateQuoteApi['list']> = yield call(
    getClientApi().privateQuote.list,
    authToken,
  );

  const positionList = mapPositionListDtoToModel(data, privateQuotesResponse.data);
  yield put(doSucceededGetPositionList({ data: positionList, total }));
}

function* refresh(action: TReduxAction) {
  try {
    const { authToken } = yield select(state => state.auth.data);
    const dto: GetPositionListDto = action?.payload;
    const { data, total }: SagaReturnType<PositionApi['list']> = yield call(getClientApi().position.list, {
      ...dto,
      authToken,
    });
    const privateQuotesResponse: SagaReturnType<PrivateQuoteApi['list']> = yield call(
      getClientApi().privateQuote.list,
      authToken,
    );

    const positionList = mapPositionListDtoToModel(data, privateQuotesResponse.data);
    yield put(doSucceededGetPositionList({ data: positionList, total }));

    const symbols = uniq(positionList.map(position => position.symbol)).join(',');
    const quoteListResponse: SagaReturnType<QuoteApi['list']> = yield call(getClientApi().quote.list, {
      queryParams: {
        symbols,
      },

      authToken,
    });
    yield put(doSucceededGetQuoteList(quoteListResponse));
    yield put(doSucceededRefreshPositionList());
  } catch (error: any) {
    yield put(doFailedRefreshPositionList(error.message));
  }
}

export function* registerPositionSagas() {
  yield takeEvery(State.actionRequested(Type.GET_POSITION_LIST), safeSaga(list, Type.GET_POSITION_LIST));
  yield takeEvery(State.actionRequested(Type.REFRESH_POSITION_LIST), refresh);
}
